
import React from "react";
import { CheckCircle } from "lucide-react";
import { Progress } from "@/components/ui/progress";
import { HiringStage } from "@/lib/types";

interface HiringProgressProps {
  hiringStages: HiringStage[];
  currentStage: number;
  progress: number;
}

const HiringProgress: React.FC<HiringProgressProps> = ({
  hiringStages,
  currentStage,
  progress,
}) => {
  return (
    <div className="mb-8">
      <div className="flex items-center justify-between mb-2">
        <span className="text-sm font-medium">Hiring Progress</span>
        <span className="text-sm font-medium">{Math.round(progress)}%</span>
      </div>
      <Progress value={progress} className="h-2" />
      
      <div className="flex justify-between mt-4">
        {hiringStages.map((stage, index) => (
          <div 
            key={stage.id}
            className={`flex flex-col items-center ${
              index === currentStage ? 'text-primary' : 
              index < currentStage ? 'text-muted-foreground' : 'text-muted'
            }`}
          >
            <div className={`
              w-8 h-8 rounded-full flex items-center justify-center mb-1
              ${index === currentStage ? 'bg-primary text-white' : 
                index < currentStage ? 'bg-primary/20' : 'bg-muted'}
            `}>
              {stage.isCompleted ? <CheckCircle className="h-4 w-4" /> : index + 1}
            </div>
            <span className="text-xs text-center hidden md:block">{stage.title}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HiringProgress;
